
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Solutions from "../pages/solutions/page";
import Contact from "../pages/contact/page";
import Consultation from "../pages/consultation/page";
import Brochure from "../pages/brochure/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/consultation",
    element: <Consultation />,
  },
  {
    path: "/brochure",
    element: <Brochure />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
